import React from 'react';

export const KeySvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_5996_19315)">
          <path d="M32.6141 3.41404C28.3101 -0.889965 21.3321 -0.889965 17.0271 3.41404C13.6361 6.80604 12.9291 11.853 14.8831 15.949L10.9671 19.864C10.3271 20.505 10.1261 21.407 10.3421 22.223L8.36909 24.195C7.89009 23.715 7.11709 23.715 6.63809 24.195L4.90709 25.927C4.42809 26.406 4.42809 27.18 4.90709 27.659L4.04009 28.523C3.56109 28.045 2.78709 28.045 2.30909 28.523L1.44309 29.39C0.96409 29.869 0.96409 30.643 1.44309 31.122C1.45809 31.138 1.47909 31.142 1.49409 31.155C0.70009 32.344 0.82609 33.967 1.87609 35.018C3.07109 36.213 5.01009 36.213 6.20509 35.018L20.0801 21.144C24.1771 23.099 29.2241 22.391 32.6151 18.998C36.9171 14.696 36.9171 7.71804 32.6141 3.41404ZM30.8831 8.60904C29.9261 9.56504 28.3741 9.56504 27.4191 8.60904C26.4631 7.65304 26.4631 6.10204 27.4191 5.14504C28.3741 4.18904 29.9261 4.18904 30.8831 5.14504C31.8391 6.10204 31.8391 7.65304 30.8831 8.60904Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_5996_19315">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18936)">
        <path d="M32.6141 3.41404C28.3101 -0.889965 21.3321 -0.889965 17.0271 3.41404C13.6361 6.80604 12.9291 11.853 14.8831 15.949L10.9671 19.864C10.3271 20.505 10.1261 21.407 10.3421 22.223L8.36909 24.195C7.89009 23.715 7.11709 23.715 6.63809 24.195L4.90709 25.927C4.42809 26.406 4.42809 27.18 4.90709 27.659L4.04009 28.523C3.56109 28.045 2.78709 28.045 2.30909 28.523L1.44309 29.39C0.96409 29.869 0.96409 30.643 1.44309 31.122C1.45809 31.138 1.47909 31.142 1.49409 31.155C0.70009 32.344 0.82609 33.967 1.87609 35.018C3.07109 36.213 5.01009 36.213 6.20509 35.018L20.0801 21.144C24.1771 23.099 29.2241 22.391 32.6151 18.998C36.9171 14.696 36.9171 7.71804 32.6141 3.41404ZM30.8831 8.60904C29.9261 9.56504 28.3741 9.56504 27.4191 8.60904C26.4631 7.65304 26.4631 6.10204 27.4191 5.14504C28.3741 4.18904 29.9261 4.18904 30.8831 5.14504C31.8391 6.10204 31.8391 7.65304 30.8831 8.60904Z" fill="#E4551D" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18936">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}